var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTotalNetBalance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.63789C0.5 4.02449 0.825611 4.33789 1.22727 4.33789H14.3182C14.7198 4.33789 15.0455 4.02449 15.0455 3.63789V2.23789C15.0455 1.07809 14.0686 0.137891 12.8636 0.137891H2.68182C1.47683 0.137891 0.5 1.07809 0.5 2.23789V3.63789ZM1.95455 2.93789V2.23789C1.95455 1.85129 2.28016 1.53789 2.68182 1.53789H12.8636C13.2653 1.53789 13.5909 1.85129 13.5909 2.23789V2.93789H1.95455Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22727 2.93945C0.825611 2.93945 0.5 3.25285 0.5 3.63945V12.0395C0.5 13.1993 1.47683 14.1395 2.68182 14.1395H14.3182C15.5232 14.1395 16.5 13.1993 16.5 12.0395V11.3395H12.1364C10.5297 11.3395 9.22727 10.0859 9.22727 8.53945C9.22727 6.99306 10.5297 5.73945 12.1364 5.73945H16.5V5.03945C16.5 3.87966 15.5232 2.93945 14.3182 2.93945H1.22727ZM10.6818 8.53945C10.6818 7.76625 11.333 7.13945 12.1364 7.13945H16.5V9.93945H12.1364C11.333 9.93945 10.6818 9.31265 10.6818 8.53945ZM12.1364 9.23945H12.8636V7.83945H12.1364V9.23945Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTotalNetBalance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_total_net_balance.59aec0ce2212553d5180c4b8bab77229.svg";